import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cuddlesLogo } from 'assets/images';
import React from 'react';

import classes from './Header.module.scss';

interface HeaderProps {
    logo?: string;
    progress?: number;
    backLabel?: string;
    onBack?: () => void;
}

export const Header: React.FC<HeaderProps> = props => {
    const logoSrc = React.useMemo(() => props.logo || cuddlesLogo, [props.logo]);

    return (
        <>
            <div className={classes.root}>
                <div>
                    {props.onBack && (
                        <button
                            type="button"
                            aria-label={props.backLabel ?? 'Back'}
                            className={classes.backButton}
                            onClick={props.onBack}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} />
                            <span>{props.backLabel ?? 'Back'}</span>
                        </button>
                    )}
                </div>
                <img alt="Logo" src={logoSrc} className={classes.logo} />
                <div></div>
            </div>

            {props.progress && (
                <div className={classes.progress}>
                    <div
                        className={classes.progressBar}
                        style={{ width: `${props.progress}%` }}
                    ></div>
                </div>
            )}
        </>
    );
};
